<mat-card class="is-private-card">
  <mat-card-header>
    <mat-card-title>
      {{Holding}} is down? <b>{{ isPrivate ? "Yes" : "No" }}</b>
    </mat-card-title>
    <ng-content select="mat-slide-toggle"></ng-content>
  </mat-card-header>
  <mat-card-content>
    <p class="description-title">
      What does this mean?
    </p>
    <p class="description-text">
      When the {{holding}} is down, investors will not receive system updates, and the {{holding}} will not be available on their Investor
      Portal. We recommend moving the {{holding}} to down mode when you want to add information to the {{holding}} retroactively, without
      notifying your investors about each of the updates that you’re making. Once you’re done making changes, put the {{holding}} back up to
      make it available again on the Investor Portal.
    </p>
  </mat-card-content>
</mat-card>
